<!--进度条-->
<template>
  <ul class="steps">
    <li
      v-for="item in stepsList"
      :key="item.step"
      :class="{ active: item.active }"
    >
      <span class="step-line"></span>
      <span class="step-number step-text">
        <template v-if="item.step === 1 && showSubmitIcon">
          <img src="@/assets/img/paymenAccount/steps-first.png" />
        </template>
        <template v-else>
          {{ item.step }}
        </template>
      </span>
      <span class="step-desc step-text">
        <span>{{ item.desc }}</span>
        <span>{{ item.time }}</span>
      </span>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'ApplicationInfo',
  components: {},
  props: {
    stepsList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    showSubmitIcon: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  watch: {},
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.steps {
  display: flex;
  width: calc(100% - 20px);
  height: 48px;
  margin-top: 20px;

  li {
    flex: 1;
    position: relative;
    margin-right: 3px;
    text-align: center;
  }

  li:last-child {
    margin-right: 0;

    .step-line {
      margin-right: 0;
    }
  }

  .step-line {
    display: inline-block;
    height: 4px;
    line-height: 4px;
    background: #d9d9d9;
    color: #fff;
    position: absolute;
    top: 10px;
    left: 0;
    font-size: 12px;
    margin-right: 3px;
    width: 100%;
  }

  .step-line:after {
    content: '';
    display: block;
    border-top: 2px solid #d9d9d9;
    border-bottom: 2px solid #d9d9d9;
    border-left: 3px solid #fff;
    position: absolute;
    right: -3px;
    top: 0;
  }

  .step-line:after {
    content: '';
    display: block;
    border-top: 2px solid transparent;
    border-bottom: 2px solid transparent;
    border-left: 3px solid #d9d9d9;
    position: absolute;
    right: -3px;
    top: 0;
    z-index: 10;
  }

  .step-line:before {
    content: '';
    display: block;
    border-top: 2px solid #d9d9d9;
    border-bottom: 2px solid #d9d9d9;
    border-left: 3px solid #fff;
    position: absolute;
    left: 0px;
    top: 0;
  }

  li:first-child .step-line {
    width: 50%;
    top: 10px;
    left: 50%;
  }

  li:last-child .step-line {
    width: 50%;
  }

  li:first-child .step-line:before {
    display: none;
  }

  .step-text {
    font-family: Source Han Sans CN;
    font-size: 14px;
    font-style: normal;
    font-weight: 350;
  }

  .step-number {
    display: inline-block;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    line-height: 24px;
    background: #c5c5c5;
    color: #fff;
    position: absolute;
    left: calc(50% - 12px);
  }

  .step-desc {
    position: relative;
    top: 30px;
    display: flex;
    flex-direction: column;
    span:first-child {
      color: #999;
    }
    span:last-child {
      font-size: 12px;
      color: #666;
      margin-top: 10px;
    }
  }

  li:last-child .step-number {
    z-index: 11;
  }

  li.active .step-line,
  li.active .step-number {
    background-color: #2587ff;
  }

  li.active .step-line:after {
    border-left-color: #2587ff;
  }

  li.active .step-line:before {
    border-top-color: #2587ff;
    border-bottom-color: #2587ff;
  }

  li.active .step-desc {
    span:first-child {
      color: #2587ff;
    }
  }
}
</style>
